import { render, staticRenderFns } from "./addCrew.vue?vue&type=template&id=30f662b1&scoped=true"
import script from "./addCrew.vue?vue&type=script&lang=js"
export * from "./addCrew.vue?vue&type=script&lang=js"
import style0 from "./addCrew.vue?vue&type=style&index=0&id=30f662b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f662b1",
  null
  
)

export default component.exports